export enum PortalType {
	MASTERSPORTAL = 'master',
	BACHELORSPORTAL = 'bachelor',
	PHDPORTAL = 'phd',
	SHORTCOURSESPORTAL = 'short',
	DISTANCELEARNINGPORTAL = 'distance_learning',
}
